import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AuthGuard } from '@auth0/auth0-angular';
import { adminGuard } from './admin.guard';
import { callbackGuard } from './callback.guard';

export const routes: Routes = [
  {
    path: 'callback',
    loadComponent: () =>
      import('./features/callback/callback.component').then(
        (m) => m.CallbackComponent,
      ),
    canActivate: [callbackGuard],
  },
  {
    path: 'home',
    loadComponent: () => import('./features/home/home').then((m) => m.Home),
    canActivate: [AuthGuard],
    title: 'BETTER | Hospitals',
  },
  {
    path: '',
    pathMatch: 'full',
    loadComponent: () => import('./features/guest/guest').then((m) => m.Guest),
    title: 'BETTER | Sign in',
  },
  {
    path: 'hospital-info/:hospitalId',
    loadComponent: () =>
      import('./features/hospital-info/hospital-info').then(
        (m) => m.HospitalInfo,
      ),
    canActivate: [AuthGuard],
  },
  {
    path: 'hospital/:hospitalId/data-set/:dataSetId',
    loadComponent: () =>
      import('./features/data-set/data-set').then((m) => m.DataSet),
    canActivate: [AuthGuard],
    title: 'BETTER | DataSet',
  },
  {
    path: 'admin',
    loadComponent: () => import('./features/admin/admin').then((m) => m.Admin),
    canActivate: [AuthGuard, adminGuard],
    title: 'BETTER | Admin',
  },
  {
    path: '**',
    redirectTo: '/home',
    title: 'BETTER',
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
